import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvertisementsComponent } from './advertisements.component';
import { TournamentBannerModule } from '@fantaz/tournaments-v2/ui/tournament-banner';

@NgModule({
  imports: [CommonModule, TournamentBannerModule],
  declarations: [AdvertisementsComponent],
  exports: [AdvertisementsComponent],
})
export class TournamentWidgetAdvertisementsModule {}
